import { resolveBrandingColors } from './buttonPresets.js';

/**
 * @typedef {Object} PortalBranding
 * @property {string} [name]
 * @property {string|null} [logo_url]
 * @property {string|null} [primary_color]
 * @property {string} [button_preset]
 * @property {string|null} [header_bg_color]
 * @property {string|null} [content_bg_color]
 * @property {string|null} [header_text_color]
 * @property {string|null} [content_text_color]
 * @property {string|null} [link_color]
 */

const FAVICON_ID = 'portal-org-favicon';

/**
 * @param {HTMLElement|null} root
 * @param {PortalBranding | null | undefined} branding
 */
export function applyPortalBranding(root, branding) {
  if (!root) {
    return;
  }

  const colors = resolveBrandingColors(branding);

  root.classList.add('portal-branded');
  root.dataset.buttonPreset = colors.button_preset;

  root.style.setProperty('--portal-header-bg', colors.header_bg_color);
  root.style.setProperty('--portal-content-bg', colors.content_bg_color);
  root.style.setProperty('--portal-header-text', colors.header_text_color);
  root.style.setProperty('--portal-content-text', colors.content_text_color);
  root.style.setProperty('--portal-link', colors.link_color);

  const accent = branding?.link_color || branding?.primary_color || colors.link_color;
  root.style.setProperty('--portal-accent', accent);

  applyFavicon(branding?.logo_url);
  applyDocumentTitle(branding?.name);
}

function applyFavicon(logoUrl) {
  let link = document.getElementById(FAVICON_ID);
  if (!logoUrl) {
    link?.remove();
    return;
  }

  if (!link) {
    link = document.createElement('link');
    link.id = FAVICON_ID;
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = logoUrl;
}

function applyDocumentTitle(name) {
  document.title = name ? `${name} portal` : 'Portal';
}
